import { render, staticRenderFns } from "./key.vue?vue&type=template&id=6ac1e4ff&"
import script from "./key.vue?vue&type=script&lang=ts&"
export * from "./key.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\sam_project\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac1e4ff')) {
      api.createRecord('6ac1e4ff', component.options)
    } else {
      api.reload('6ac1e4ff', component.options)
    }
    module.hot.accept("./key.vue?vue&type=template&id=6ac1e4ff&", function () {
      api.rerender('6ac1e4ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/key.vue"
export default component.exports